import React from 'react';

const acpBrands = [
    { name: 'EUROBOND', category: 'ACP Panel Brand'},
    { name: 'ALUDECOR', category: 'ACP Panel Brand'}
];

const glassBrands = [
    { name: 'SAINT-GOBAIN', category: 'Glass Facade Brand'}
];

class ClientsLogo extends React.Component {
    render() {
        return (
            <div className="section-full mobile-page-padding p-t70 p-b70 bg-gray">
                <div className="container">
                    <div className="section-head text-center m-b40">
                        <div className="sx-separator-outer separator-center">
                            <div className="sx-separator bg-white">
                                <h3 className="sep-line-one" style={{ fontSize: 'clamp(22px, 4vw, 32px)', fontWeight: '800' }}>
                                     Regular Brands
                                </h3>
                            </div>
                        </div>
                        {/* <p style={{ color: '#666', fontSize: '15px', maxWidth: '650px', margin: '15px auto 0', textAlign: 'center' }}>
                            We partner with world-renowned material manufacturers to deliver certified quality and long-lasting elevation solutions.
                        </p> */}
                    </div>

                    <div className="row justify-content-center">
                        {/* ACP BRANDS */}
                        {acpBrands.map((brand, idx) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={idx}>
                                <div 
                                    style={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '16px',
                                        padding: '30px 25px',
                                        textAlign: 'center',
                                        boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
                                        border: '1px solid #e8e8e8',
                                        borderTop: '4px solid #f03a02',
                                        transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-6px)';
                                        e.currentTarget.style.boxShadow = '0 14px 35px rgba(240, 58, 2, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.06)';
                                    }}
                                >
                                    <span style={{
                                        backgroundColor: 'rgba(240, 58, 2, 0.08)',
                                        color: '#f03a02',
                                        padding: '4px 14px',
                                        borderRadius: '20px',
                                        fontSize: '11px',
                                        fontWeight: '800',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        marginBottom: '16px'
                                    }}>
                                        ACP Brand
                                    </span>
                                    <h3 style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: '28px',
                                        fontWeight: '900',
                                        color: '#111111',
                                        letterSpacing: '1.5px',
                                        marginBottom: '8px'
                                    }}>
                                        {brand.name}
                                    </h3>
                                    <p style={{ fontSize: '13.5px', color: '#666666', margin: 0, lineHeight: '1.5' }}>
                                        {brand.desc}
                                    </p>
                                </div>
                            </div>
                        ))}

                        {/* GLASS BRAND */}
                        {glassBrands.map((brand, idx) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={`glass-${idx}`}>
                                <div 
                                    style={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '16px',
                                        padding: '30px 25px',
                                        textAlign: 'center',
                                        boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
                                        border: '1px solid #e8e8e8',
                                        borderTop: '4px solid #f03a02',
                                        transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-6px)';
                                        e.currentTarget.style.boxShadow = '0 14px 35px rgba(240, 58, 2, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.06)';
                                    }}
                                >
                                    <span style={{
                                        backgroundColor: 'rgba(240, 58, 2, 0.08)',
                                        color: '#f03a02',
                                        padding: '4px 14px',
                                        borderRadius: '20px',
                                        fontSize: '11px',
                                        fontWeight: '800',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        marginBottom: '16px'
                                    }}>
                                        Glass Brand
                                    </span>
                                    <h3 style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: '26px',
                                        fontWeight: '900',
                                        color: '#111111',
                                        letterSpacing: '1px',
                                        marginBottom: '8px'
                                    }}>
                                        {brand.name}
                                    </h3>
                                    <p style={{ fontSize: '13.5px', color: '#666666', margin: 0, lineHeight: '1.5' }}>
                                        {brand.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default ClientsLogo;
